<template>
  <div class="collection-organiser">
    <div class="tabs is-danger mb-2">
      <ul style="position: relative">
        <li
          v-for="collection in collectionList"
          :key="`tab-${collection.id}`"
          :class="{ 'is-active': selectedCollectionId === collection.id }"
        >
          <a @click="handleSelectCollection(collection.id)">
            <div
              class="is-flex is-align-items-center"
              :class="{
                'has-text-danger': Object.keys(collection.errors).length > 0,
              }"
            >
              <span class="icon is-small">
                <i
                  v-if="Object.keys(collection.errors).length > 0"
                  class="fa fa-exclamation-triangle"
                  aria-hidden="true"
                ></i>
                <i
                  v-else
                  class="fa fa-layer-group fa-xs"
                  aria-hidden="true"
                ></i>
              </span>
              <span
                v-tooltip="`${collection.name}`"
                style="
                  max-width: 130px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                :class="!collection.name ? 'is-italic' : ''"
              >
                {{ collection.name || 'Unknown' }}
              </span>
              <span
                v-if="showDatasetCount && collection.datasetsList.length > 0"
              >
                <span class="tag is-success is-light ml-2 has-text-weight-bold">
                  <span class="icon pr-2">
                    <i class="fa-regular fa-copy fa-sm" />
                  </span>
                  {{ collection.datasetsList.length }}
                </span>
              </span>
              <span
                v-if="canEdit"
                v-tooltip="`Remove ${collection.name}`"
                class="delicon icon is-small"
                @click.stop="handleRemoveCollection(collection.id)"
              >
                <i class="fa fa-times" aria-hidden="true" />
              </span>
            </div>
          </a>
        </li>
        <li
          v-if="canEdit && remainingFilesCount > 0"
          style="display: flex; flex-wrap: nowrap"
        >
          <a @click="handleAddCollection()">
            <span class="icon is-small">
              <i class="fa fa-plus" aria-hidden="true"></i>
            </span>
            <span>Create collection</span>
          </a>
        </li>
        <li
          style="
            background: white;
            position: sticky;
            right: 0;
            margin: auto 0.5rem;
          "
        >
          <span
            v-if="showCount && collectionCount > 1"
            class="tag is-size-7 is-rounded is-primary has-text-weight-bold"
          >
            {{ collectionCount }}
            {{ pluralize('collection', collectionCount) }}
          </span>
        </li>
      </ul>
    </div>
    <slot
      v-if="collectionCount > 0 && selectedCollectionId"
      name="collection"
      :selected-collection-id="selectedCollectionId"
    />
  </div>
</template>

<script>
import pluralize from 'pluralize'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CollectionOrganiser',
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
    showCount: {
      type: Boolean,
      default: false,
    },
    showDatasetCount: {
      type: Boolean,
      default: false,
    },
    selectedCollectionId: {
      type: String,
      default: '',
    },
    remainingFilesCount: {
      type: Number,
      default: 0,
    },
    resetCollections: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('dataloader/collections', [
      'collectionList',
      'collectionCount',
      'newCollection',
    ]),
    ...mapGetters('dataloader/assay', ['assayId', 'assayBaseCollectionData']),
  },
  methods: {
    pluralize,
    ...mapActions('dataloader/collections', [
      'addCollection',
      'removeCollection',
      'wipeCollections',
    ]),
    ...mapMutations('dataloader/collections', {
      selectCollectionById: 'SELECT_COLLECTION_BY_ID',
    }),
    handleAddCollection() {
      this.addCollection(this.newCollection)
    },
    handleSelectCollection(id) {
      this.selectCollectionById(id)
    },
    handleRemoveCollection(id) {
      this.removeCollection(id)
    },
  },
  async mounted() {
    // If there are no staged datasets, wipe and initialize collections
    if (this.resetCollections) await this.wipeCollections()
    if (this.collectionCount === 0) {
      await this.addCollection(this.assayId ? this.assayBaseCollectionData : {})
    }
    // Automatically select the first collection if one exists and none is selected
    if (!this.selectedCollectionId && this.collectionList.length > 0) {
      this.selectCollectionById(this.collectionList[0].id)
    }
  },
}
</script>

<style scoped>
.collection-organiser div.tabs ul li a {
  border-bottom-width: 3px;
}

.delicon.icon:hover {
  color: var(--color-danger);
}
</style>
